'use client';

import Link from 'next/link';
import Image from '../image';
import { SmallButton } from '../button';
import { PageList } from '../page';
import { useMedia } from '@ssv-website/hooks';

interface IServiceCardProps {
  title: string;
  subTitle: string;
  imageUrl: string;
  linkText: string;
  linkHref: string;
  desc: string;
}

interface IServiceCardListProps {
  data: Array<IServiceCardProps>;
}

export const ServiceCard: React.FC<IServiceCardProps> = ({
  title,
  subTitle,
  linkText,
  imageUrl,
  desc,
  linkHref,
}) => {
  const _linkText = !linkText ? '去了解' : linkText;
  return (
    <div className="bg-bg rounded-lg p-[30px] mobile:p-5 flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div>
          <span className="text-base leading-none text-primary mobile:text-sm font-500">
            {title}
          </span>
          <p className="text-sm -leading-[1px] text-primary/[.6] mt-2 mr-2 line-clamp-1 mobile:text-xs">
            {subTitle}
          </p>
        </div>
        <Link
          href={linkHref || '/'}
          className="mobile:hidden min-w-[120px] max-w-[200px]"
        >
          <SmallButton>{_linkText}</SmallButton>
        </Link>
      </div>
      <div className="bg-white p-5 gap-5 rounded-md flex items-center">
        <Image
          src={imageUrl}
          width={99}
          height={110}
          alt="服务图片"
          className="w-[99px] h-[110px] mobile:w-[79px] mobile:h-[88px]"
        />
        <p className="text-sm leading-none text-primary line-clamp-3 mobile:text-xs">
          {desc}
        </p>
      </div>
      <Link href={linkHref || ''} className="hidden mobile:block mt-5 w-fit">
        <SmallButton>{_linkText}</SmallButton>
      </Link>
    </div>
  );
};

export const ServiceCardList: React.FC<IServiceCardListProps> = ({
  data = [],
}) => {
  const isMobile = useMedia('mobile');
  return (
    <PageList
      data={data}
      className={`grid grid-cols-2 gap-5 mobile:grid-cols-1 ${
        data.length > 1 ? 'mobile:grid-rows-2' : ''
      }`}
      columns={isMobile ? 2 : 4}
      renderItem={(m: any, i: number) => <ServiceCard key={i} {...m} />}
    />
  );
};
